// Keep provider/server messages out of the UI: they can contain credentials or
// internal details. Preserve the failure stage instead of blaming every failure
// on the password.
export function userLoginError(error, stage) {
  if (stage === "oauth-session") {
    return "We could not finish sign-in or read your session. Retry the connection, or return to the app and start a new login request.";
  }
  if (stage === "delivery") {
    if (["UNAUTHENTICATED", "UNAUTHORIZED"].includes(error?.code)) {
      return "You signed in, but the connection service rejected your session. Please sign in again. If this continues, contact support.";
    }
    if (error?.code === "BAD_REQUEST") {
      return "You signed in, but the connection request is invalid or expired. Please return to the app and start a new login request.";
    }
    return "You signed in, but we could not complete the connection. Retry the connection, or return to the app and start a new login request.";
  }
  if (stage === "session") {
    return "You signed in, but your session could not be read. Retry the connection, or sign in again.";
  }
  switch (error?.name) {
    case "NotAuthorizedException":
    case "UserNotFoundException":
      return stage === "verification"
        ? "Your verification session has expired. Please sign in again."
        : "We could not verify your email and password. Check your details, or use Google if that is how you registered.";
    case "CodeMismatchException":
      return "The verification code is incorrect. Please try again.";
    case "ExpiredCodeException":
      return "The verification code has expired. Please sign in again.";
    case "LimitExceededException":
    case "TooManyRequestsException":
      return "Too many attempts. Please wait before trying again.";
    case "InvalidPasswordException":
      return "Your new password does not meet the password requirements. Please choose a stronger password.";
    case "UserAlreadyAuthenticatedException":
      return "A browser session is still active. Please try signing in again.";
    case "AuthTokenConfigException":
    case "OAuthNotConfigureException":
    case "InvalidOriginException":
      return "Sign-in is not configured correctly for this page. Please return to the app and start a new login request.";
    default:
      return stage === "google"
        ? "Google sign-in could not be started. Please try again."
        : stage === "verification"
          ? "We could not complete verification. Check your response and try again."
          : "The sign-in service could not complete your request. Please try again.";
  }
}
